import React from 'react';
import cx from 'classnames';

import Star from 'components/star/star';
import { SeasonEventDto } from 'utils/api/dto';
import { FAV_AND_RECENT_TYPE_EVENT } from 'widgets/favorites/constant';

import ResultWrapper from '../../search-components/result-wrapper';
import styles from '../../search-components/result-list.module.css';
import { FavoriteToggleHandler, SelectItemHandler } from '../search-dropdown/types';

type EventSearchResultProps = {
    processing: boolean;
    events: SeasonEventDto[];
    isFavorite?: boolean;
    /** the favorite events: matched by their id */
    favEventList?: { id: number }[];
    handleAddRecentData: SelectItemHandler;
    handleFavoriteToggle: FavoriteToggleHandler;
};

/** The found events of the events page search */
const EventSearchResult = ({
    processing,
    events,
    isFavorite = false,
    favEventList,
    handleAddRecentData,
    handleFavoriteToggle
}: EventSearchResultProps) => (
    <ResultWrapper processing={processing} isNoData={!events.length}>
        {events.map(({ name, id }) => {
            const favoriteEvent = isFavorite ? favEventList?.find(item => item.id === id) : undefined;

            return (
                <div key={id} className={styles.row}>
                    <div className={styles.item}>
                        <button
                            type="button"
                            className={cx(styles.link, styles.eventLink)}
                            onClick={() => handleAddRecentData(id, FAV_AND_RECENT_TYPE_EVENT)}
                        >
                            {name ?? '-'}
                        </button>
                    </div>
                    {isFavorite ? (
                        <button
                            type="button"
                            className={styles.favoriteButton}
                            onClick={() =>
                                handleFavoriteToggle(favoriteEvent?.id, { id, type: FAV_AND_RECENT_TYPE_EVENT })
                            }
                        >
                            <Star active={!!favoriteEvent?.id} height={20} width={20} />
                        </button>
                    ) : null}
                </div>
            );
        })}
    </ResultWrapper>
);

export default EventSearchResult;
